export const FullStackPricingSectionData = {
  heading:
    'Pay fees one time and get Peer to peer learning for lifetime.Unlock your software engineering potential that takes you to',
  highlightedHeading: ' top 1% club',
  specification: [
    'Solve 200+ Questions',
    'Exclusive Devsnest Community',
    'Build a portfolio of 20+ real-world projects'
  ]
}

export const DSAPricingSectionData = {
  heading:
    'Pay fees one time and get Peer to peer learning for lifetime.Unlock your software engineering potential that takes you to',
  highlightedHeading: ' top 1% club',
  specification: [
    'Solve 200+ Questions',
    'Exclusive Devsnest Community',
    'Coding contest to build your Competitive Skills'
  ]
}

export const FrontendPricingSectionData = {
  heading:
    'Pay fees one time and get Peer to peer learning for lifetime.Unlock your software engineering potential that takes you to',
  highlightedHeading: ' top 1% club',
  specification: [
    'Build 20+ real-world projects',
    'Exclusive Devsnest Community',
    'Build a portfolio of 10+ real-world projects'
  ]
}

export const BackendPricingSectionData = {
  heading:
    'Pay fees one time and get Peer to peer learning for lifetime.Unlock your software engineering potential that takes you to',
  highlightedHeading: ' top 1% club',
  specification: [
    'Build 20+ real-world projects',
    'Exclusive Devsnest Community',
    'Build a portfolio of 10+ real-world projects'
  ]
}

export const PricingSectionData = {
  dsa: DSAPricingSectionData,
  frontend: FrontendPricingSectionData,
  fullstack: FullStackPricingSectionData,
  backend: BackendPricingSectionData
} as const
